
import _memoize from "lodash/memoize"
import _once from "lodash/once"
import Promise from "plugins/bluebird/index"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

const getFetchAllAssetInfoPromise = _once(() => {
  return q_ajax_3(
    {
      url:     "/apps/spacious_website/assets",
      type:    "GET",
    },
    {
      error_tracking_options: {
        endpoint_identifier: "app/assets/javascripts/app/assets_info_store#fetch",
      },
    },
  )
})

const fetch = _memoize((logical_path: string): Promise<{url: string}> => {
  return getFetchAllAssetInfoPromise()
  .then(({data}) => {
    if (logical_path in data) {
      return data[logical_path]
    }

    throw new Error(`asset with logical_path absent: <${logical_path}>`)
  })
})

export default {
  fetch,
}
